import { ColumnSizeTypes, SizeBasedColumnClasses } from "./uw-table.model";

export function getColumnClass(noOfdisplayedColumns:number, size: ColumnSizeTypes): string {
  if (noOfdisplayedColumns > 3) {
    return SizeBasedColumnClasses[size];
  }

  return '';
}